<template>
  <base-modal height="600"
              :show="show"
              :padding="false"
              @close="close" >
    <div slot="header">
      {{ $t("ourLocations") }}
    </div>
    <geofence-list @close="close" />
  </base-modal>
</template>

<script>
  import GeofenceList from '@/components/Common/Geofence/GeofenceList'
  import modalMixin from '@/mixins/modalMixin.js'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      GeofenceList
    },

    beforeMount() {
      this.setOpenListener('geofence')
    }
  }
</script>
